import { usePage } from '@inertiajs/vue3'

export function useRouting() {
    const page = usePage()

    const href = (path = '', forceLocale= '') => {
        let locale = forceLocale || page.props.locale
        let url = '/' + locale + path
        return stripTrailingSlash(url)
    }

    const url = (path = '', forceLocale= '') => {
        const baseUrl = page.props.baseUrl
        let locale = forceLocale || page.props.locale
        let url = '/' + locale + path
        return baseUrl + stripTrailingSlash(url)
    }

    const stripTrailingSlash = (str) => {
        return str.endsWith('/') ?
            str.slice(0, -1) :
            str;
    };

    return {
        page,
        href,
        url
    }
}
